import { Spinner } from '@change/ds-core-ui';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PsfSharePagePrefetchedDataProps } from 'src/app/pages/psf/share/pageContext';
import { prefetchPageContext, PsfSharePageContextProvider } from 'src/app/pages/psf/share/pageContext';
import { isLoaded } from 'src/app/shared/utils/async';

import { Layout } from '../layout';

import { PsfShareErrorHandler } from './ErrorHandler';

export const PsfShare = withPrefetchedData(
	function PsfShare({ prefetchedData }: PsfSharePagePrefetchedDataProps) {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<PsfSharePageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PsfShareErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</PsfSharePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
		pageTitle: ({ i18n, prefetchedData, fromTemplate }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return undefined;
			}
			const { ask } = prefetchedData.pageData.pageData.petition;
			return fromTemplate(`${i18n.translate('fe.pages.petition_share.title')} · ${ask}`);
		},
	},
);
